// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.banner-section-learn {
  max-height: 400px;
  overflow: hidden;
  position: relative;
  width: 99.4vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}
.banner-section-learn .main-wrapper {
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.banner-section-learn figure {
  text-align: center;
}
@media only screen and (max-width: 1124px) and (min-width: 1025px) {
  .banner-section-learn figure {
    position: relative;
    right: 350px;
  }
}
@media only screen and (max-width: 1240px) and (min-width: 1125px) {
  .banner-section-learn figure {
    position: relative;
    right: 200px;
  }
}
.banner-section-learn img {
  max-width: none !important;
  height: 400px !important;
}
@media (max-width: 1024px) {
  .banner-section-learn img {
    max-width: none !important;
    height: auto !important;
  }
}
.banner-section-learn::after {
  clear: both;
  content: "";
  display: block;
}

.banner-caption-learn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}
.banner-caption-learn h1 {
  font-family: "Omnes-ATT-W02";
  font-weight: bold;
  line-height: 45px;
  margin: 0;
  padding-bottom: 20px;
  font-size: 38px;
  color: #191919;
}
@media (max-width: 1024px) {
  .banner-caption-learn h1 {
    font-size: 20px;
  }
}
.banner-caption-learn p {
  font-family: "Omnes-ATT-W02";
  font-size: 16px;
  color: #191919;
}

.btn-eligibility {
  float: left;
  margin-right: 20px;
  font-size: 16px;
}
.btn-eligibility .btn {
  margin: 0;
}

.learn-more {
  font-weight: bold;
}

.letsGetStarted {
  padding-top: 10px;
}
.letsGetStarted a {
  font-weight: bold;
}

.align {
  margin-top: 10px;
}
.align span {
  display: block;
}

.tab-section {
  margin: 30px 0 25px;
  position: relative;
}

.model-cover .model-box .modal-body {
  height: auto !important;
  padding: 0 30px;
}

@media (max-width: 1024px) {
  .main {
    padding: 0;
  }
  .tab-section {
    height: auto !important;
    margin: 0;
  }
  .tab-section .tab-nav {
    width: unset;
  }
  .banner-section-learn {
    max-height: none;
  }
  .banner-section-learn figure img {
    width: 100%;
  }
  .banner-caption-learn {
    margin: 15px 0;
    position: relative;
    top: 0;
    transform: initial;
  }
  .banner-caption-learn h1 {
    line-height: initial;
  }
  .btn-eligibility {
    float: none;
    margin-bottom: 20px;
    margin-right: 0;
    text-align: center;
  }
  .btn-eligibility .btn {
    width: 100%;
  }
  .learn-more {
    font-weight: normal;
  }
  .align {
    text-align: center;
  }
  .align span {
    display: inline;
  }
}
.msg-content {
  background-color: hsl(150, 100%, 24%);
  color: white;
  padding: 30px 15px;
}

.tab-header {
  padding-bottom: 20px;
  padding-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/learn/learn.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AAmJF;AAjJE;EACA,6BAAA;EACA,8BAAA;AAmJF;AAhJE;EACE,kBAAA;AAkJJ;AAjJI;EAFF;IAGI,kBAAA;IACA,YAAA;EAoJJ;AACF;AAnJI;EANF;IAOI,kBAAA;IACA,YAAA;EAsJJ;AACF;AAnJG;EACC,0BAAA;EACA,wBAAA;AAqJJ;AF5JI;EEWA;IACA,0BAAA;IACA,uBAAA;EAoJF;AACF;AAjJE;EACE,WAAA;EACA,WAAA;EACA,cAAA;AAmJJ;;AA/IA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AAkJF;AAhJE;EACE,4BAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,oBAAA;EAIA,eAAA;EACA,cAAA;AA+IJ;AFvLI;EE8BF;IAOE,eAAA;EAsJF;AACF;AAlJE;EACE,4BAAA;EACA,eAAA;EACA,cAAA;AAoJJ;;AAhJA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;AAmJF;AAjJE;EACE,SAAA;AAmJJ;;AA/IA;EACE,iBAAA;AAkJF;;AAhJA;EACE,iBAAA;AAmJF;AAlJI;EACA,iBAAA;AAoJJ;;AAhJA;EACE,gBAAA;AAmJF;AAlJE;EACE,cAAA;AAoJJ;;AAhJA;EACE,mBAAA;EACA,kBAAA;AAmJF;;AAjJA;EACE,uBAAA;EACA,eAAA;AAoJF;;AFtOI;EEqFF;IACE,UAAA;EAqJF;EAlJA;IACE,uBAAA;IACA,SAAA;EAoJF;EAnJE;IACE,YAAA;EAqJJ;EAjJA;IACE,gBAAA;EAmJF;EAhJI;IACE,WAAA;EAkJN;EA7IA;IACE,cAAA;IACA,kBAAA;IACA,MAAA;IACA,kBAAA;EA+IF;EA7IE;IACE,oBAAA;EA+IJ;EA3IA;IACE,WAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;EA6IF;EA3IE;IACE,WAAA;EA6IJ;EAzIA;IACE,mBAAA;EA2IF;EAxIA;IACE,kBAAA;EA0IF;EAxIE;IACE,eAAA;EA0IJ;AACF;AAtIA;EACE,qCAAA;EACA,YAAA;EACA,kBAAA;AAwIF;;AArIA;EACE,oBAAA;EACA,iBAAA;AAwIF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.banner-section-learn {\n  max-height: 400px;\n  overflow: hidden;\n  position: relative;\n  width: calc(100vw - 0.6vw);\n  left: 50%;\n  right: 50%;\n  margin-left: -50vw;\n  margin-right: -50vw;\n\n  .main-wrapper{\n  padding-left: 20px !important;\n  padding-right: 20px !important;\n  }\n\n  figure {\n    text-align: center;\n    @media only screen and (max-width: 1124px) and (min-width: 1025px){\n      position: relative;\n      right: 350px;\n    }\n    @media only screen and (max-width: 1240px) and (min-width: 1125px){\n      position: relative;\n      right: 200px;\n    }\n  }\n\n   img{\n    max-width: none !important;\n    height : 400px !important;\n  }\n\n  @include respond-to(small){\n    img{\n    max-width: none !important;\n    height : auto !important;\n  }\n}\n\n  &::after {\n    clear: both;\n    content: '';\n    display: block;\n  }\n}\n\n.banner-caption-learn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 100%;\n\n  h1 {\n    font-family: 'Omnes-ATT-W02';\n    font-weight: bold;\n    line-height: 45px;\n    margin: 0;\n    padding-bottom: 20px;\n   @include respond-to(small){\n    font-size: 20px;\n   }\n    font-size: 38px;\n    color:#191919;\n  }\n  p{\n    font-family: 'Omnes-ATT-W02';\n    font-size: 16px;\n    color:#191919;\n  }\n}\n\n.btn-eligibility {\n  float: left;\n  margin-right: 20px;\n  font-size: 16px;\n\n  .btn {\n    margin: 0;\n  }\n}\n\n.learn-more {\n  font-weight: bold;\n}\n.letsGetStarted{\n  padding-top: 10px;\n    a{\n    font-weight: bold;\n    }\n  }\n\n.align {\n  margin-top: 10px;\n  span {\n    display: block;\n  }\n}\n\n.tab-section {\n  margin: 30px 0 25px;\n  position: relative;\n}\n.model-cover .model-box .modal-body{\n  height: auto !important;\n  padding: 0 30px;\n}\n@include respond-to(small) {\n  .main {\n    padding: 0;\n  }\n\n  .tab-section {\n    height: auto !important; //added to override Tab Component css in mobile view;\n    margin: 0;\n    .tab-nav{\n      width:unset;\n     }\n  }\n\n  .banner-section-learn {\n    max-height: none;\n\n    figure {\n      img {\n        width: 100%;\n      }\n    }\n  }\n\n  .banner-caption-learn {\n    margin: 15px 0;\n    position: relative;\n    top: 0;\n    transform: initial;\n\n    h1 {\n      line-height: initial;\n    }\n  }\n\n  .btn-eligibility {\n    float: none;\n    margin-bottom: 20px;\n    margin-right: 0;\n    text-align: center;\n\n    .btn {\n      width: 100%;\n    }\n  }\n\n  .learn-more {\n    font-weight: normal;\n  }\n\n  .align {\n    text-align: center;\n\n    span {\n      display: inline;\n    }\n  }\n}\n\n.msg-content {\n  background-color: color(success, base);\n  color: color(default, light);\n  padding: 30px 15px;\n}\n\n.tab-header {\n  padding-bottom: 20px;\n  padding-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
